import React, { useState, useEffect, useRef, Fragment } from 'react'
import { useWithAuth } from '../../containers/App'
import { useMutation } from 'react-query'
import { useNotifications } from '../../containers/Notifications'
import styled from 'styled-components'

import Button from '../../components/Button'
import Heading from '../../components/Heading'
import Layout from '../../components/Layout'
import colors from '../../styles/colors'

import {
  ActiveQuestion,
  ActiveQuestionHeader,
  questionType,
  initialValuesSingle,
} from './utils'

// @ts-ignore @todo add apprioprate declaration file
import addIconRed from '../../images/addIconRed.svg'
// @ts-ignore @todo add apprioprate declaration file
import editIcon from '../../images/grayEditIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import deleteIcon from '../../images/deleteIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import saveIcon from '../../images/graySaveIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import imageIcon from '../../images/imageIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import previewIcon from '../../images/whitePreviewIcon.svg'
// @ts-ignore @todo add apprioprate declaration file
import shareIconUp from '../../images/whiteShareIconUp.svg'
// @ts-ignore @todo add apprioprate declaration file
import whiteSaveIcon from '../../images/whiteSaveIcon.svg'

function EditSurvey() {
  const bottom = useRef(null)
  const surveyId = location.pathname.substring(
    location.pathname.lastIndexOf('/') + 1
  ) //dirty but passing props in navigate gatsby creates bugs
  const [images, setImages] = useState([])
  const [toDeleteImages, setToDeleteImages] = useState([])
  const [sentImages, setSentImages] = useState({ files: [], filesId: [] })
  const [editQuestion, setEditQuestion] = useState({ id: null })
  const [currentQuestionType, setCurrentQuestionType] = useState('SINGLE')
  const [editDoneQuestion, setEditDoneQuestion] = useState({
    index: null,
    ready: false,
    doneQuestion: null,
  })
  const [questions, setQuestions] = useState<ActiveQuestion>(null)
  const [newAnswer, setNewAnswer] = useState({
    ready: false,
    answer: null,
  })
  const [survey, setSurvey] = useState({
    title: '',
    description: '',
  })
  const [doneQuestions, setDoneQuestions] = useState<Array<ActiveQuestion>>([])
  const endpoint = '/form/rest/survey/'
  const editQuestionEndpoint = '/form/rest/survey/question/'
  const surveyImagesEndpoint = '/file/rest/image/'
  const headerEndpoint = '/form/rest/survey/header/'
  const fileUploadEndpoint = '/file/rest/image/upload'
  const questionDeleteEndpoint = '/form/rest/survey/question/'
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const handleAbort = () => {
    questions.type === 'IMAGE' &&
      questions.answerOptions.map(
        async (answer) =>
          answer.fileId !== null &&
          (await handleImageDeleteAsync(answer.fileId))
      )
    setQuestions(null)
    setCurrentQuestionType('SINGLE')
    setImages([])
    setNewAnswer({
      ready: false,
      answer: null,
    })
    setEditQuestion({ id: null })
  }

  const handleAbortEditQuestion = () => {
    if (currentQuestionType === 'IMAGE') {
      const originalFileIds = editDoneQuestion.doneQuestion.answerOptions.map(
        (answer) => answer.fileId
      )
      const arrayOfFileIdsToDelete = [...images, ...toDeleteImages]
        .filter((image) => !originalFileIds.includes(image.fileId))
        .map((value) => value.fileId)
      arrayOfFileIdsToDelete.map(
        async (fileId) => await handleImageDeleteAsync(fileId)
      )
      setEditDoneQuestion({
        index: null,
        ready: false,
        doneQuestion: null,
      })
      setQuestions(null)
      setCurrentQuestionType('SINGLE')
      setImages([])
      setToDeleteImages([])
    } else {
      setEditDoneQuestion({
        index: null,
        ready: false,
        doneQuestion: null,
      })
      setQuestions(null)
      setCurrentQuestionType('SINGLE')
      setImages([])
      setToDeleteImages([])
    }
  }
  const handleAddAnswer = () => {
    setQuestions({
      ...questions,
      answerOptions: [
        ...questions.answerOptions,
        {
          answer: newAnswer.answer !== null ? newAnswer.answer : 'Odpowiedź',
        },
      ],
    })
    setNewAnswer({ ready: false, answer: null })
  }
  const handleEditAnswer = (element) => {
    currentQuestionType === 'IMAGE'
      ? setQuestions({
          ...questions,
          answerOptions: questions.answerOptions.map((answer, index) =>
            index === editQuestion.id
              ? {
                  fileId: questions.answerOptions[index].fileId,
                  answer: element.target.value,
                }
              : answer
          ),
        })
      : setQuestions({
          ...questions,
          answerOptions: questions.answerOptions.map((answer, index) =>
            index === editQuestion.id
              ? { answer: element.target.value }
              : answer
          ),
        })
  }
  const handleDeleteAnswer = (id) => {
    setQuestions({
      ...questions,
      answerOptions: questions.answerOptions.filter(
        (answer, index) => index !== id && answer
      ),
    })
    if (currentQuestionType === 'IMAGE' && editDoneQuestion.ready === false) {
      images[id]?.fileId && handleImageDelete(images[id].fileId)
      setImages(images.filter((image, index) => index !== id && image))
    }
    if (currentQuestionType === 'IMAGE' && editDoneQuestion.ready === true) {
      setToDeleteImages([
        ...toDeleteImages,
        ...images.filter((image, index) => index === id && image),
      ])
    }
  }
  const handleQuestionTypeChange = (type) => {
    setCurrentQuestionType(type)
    const initialValues = questionType.find((types) => types.value === type)
      .initialValue
    editDoneQuestion.ready
      ? setQuestions({
          ...initialValues,
          question: questions.question,
        })
      : setQuestions(initialValues)
    setImages([])
  }
  const handleAddQuestion = () => {
    if (questions.question === '') {
      notify(
        'Pole "treść pytania" musi być wypełnione i może mieć max 200 znaków',
        'error'
      )
    } else if (questions.type !== 'IMAGE') {
      setNewAnswer({
        ready: false,
        answer: null,
      })
      setEditQuestion({ id: null })
      mutateQuestion(questions)
    } else if (
      questions.answerOptions.filter((answer) => answer.fileId === null)
        .length === 0
    ) {
      setNewAnswer({
        ready: false,
        answer: null,
      })
      setEditQuestion({ id: null })
      toDeleteImages.length !== 0 &&
        toDeleteImages.map(
          async (image) => await handleImageDeleteAsync(image.fileId)
        )
      mutateQuestion(questions)
    } else {
      notify('Wymagane są obrazki do pytań', 'error')
    }
  }
  const handleFileUpload = async (element, questionId) => {
    if (element.target.files[0]) {
      const formData = new FormData()
      formData.append('file', element.target.files[0])
      const uploadFile = async () => {
        const result = await withAuth(fileUploadEndpoint, {
          method: 'POST',
          isFile: true,
          headers: {
            Accept: 'application/json',
          },
          payload: formData,
        })
        setQuestions({
          ...questions,
          answerOptions: questions.answerOptions.map((answer, index) =>
            index === questionId
              ? { ...answer, fileId: result.id }
              : { ...answer }
          ),
        })
        return result
      }
      const file = await uploadFile()
      const image = await fetchSurveyAnswerImage(file.id)
      setImages([
        ...images,
        { file: image, fileId: file.id, questionId: questionId },
      ])
    } else null
  }
  const scrollToBottom = () => {
    bottom.current?.scrollIntoView({ behavior: 'smooth' })
  }
  useEffect(() => {
    scrollToBottom()
  }, [questions])

  const fetchSurvey = async () => {
    const result = await withAuth(`${endpoint}${surveyId}`, {
      method: 'GET',
    })
    return result
  }
  const fetchSurveyAnswerImage = async (id) => {
    const result = await withAuth(`${surveyImagesEndpoint}${id}`, {
      method: 'GET',
      responseType: 'blob',
    })
    return URL.createObjectURL(result)
  }
  const fetchData = async () => {
    try {
      const result = await fetchSurvey()
      setSurvey({
        title: result.title,
        description: result.description,
      })
      setDoneQuestions(result.questions)
      const arrayOfFileids = result.questions
        .filter((question) => question.type === 'IMAGE')
        .map((question) =>
          question.answerOptions.map((option) => option.fileId)
        )
        .flat(1)

      const arrayOfImages = await Promise.all(
        arrayOfFileids.map(async (id) => await fetchSurveyAnswerImage(id))
      )

      setSentImages({ files: arrayOfImages, filesId: arrayOfFileids })
    } catch {
      //notify('Nie udało się pobrać ankiety', 'error')
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const [mutateHeader] = useMutation<any, ActiveQuestionHeader>((values) =>
    withAuth(`${headerEndpoint}${surveyId}`, {
      method: 'PUT',
      payload: values,
    })
      .then((res) => {
        if ('fieldErrors' in res) {
          // @todo notifications
        } else {
          notify('Edytowano nagłówek ankiety', 'success')
        }
      })
      .catch((e) => {
        e.status === 403 && notify(' brak wymaganych uprawnień', 'error')
      })
  )
  const [mutateQuestion] = useMutation<any, ActiveQuestion>((values) =>
    withAuth(
      editDoneQuestion.ready === true
        ? `${editQuestionEndpoint}${editDoneQuestion.doneQuestion.id}`
        : `${endpoint}${surveyId}/question`,
      {
        method: editDoneQuestion.ready === true ? 'PUT' : 'POST',
        payload: values,
      }
    )
      .then((res) => {
        if ('fieldErrors' in res) {
          notify(
            'Pole "treść pytania" musi być wypełnione i może mieć max 200 znaków',
            'error'
          )
        } else {
          notify(
            editDoneQuestion.ready === true
              ? 'Edytowano pytanie ankiety'
              : 'Dodano pytanie do ankiety',
            'success'
          )
          setQuestions(null)
          setCurrentQuestionType('SINGLE')
          setImages([])
          setToDeleteImages([])
          fetchData()
          setEditDoneQuestion({
            index: null,
            ready: false,
            doneQuestion: null,
          })
        }
      })
      .catch((e) => {
        e.status === 403 && notify(' brak wymaganych uprawnień', 'error')
      })
  )
  const [handleImageDelete] = useMutation<any, number>(
    async (imageId) =>
      await withAuth(`${surveyImagesEndpoint}${imageId}`, {
        method: 'DELETE',
      })
        .then((res) => {
          if ('fieldErrors' in res) {
            // @todo notifications
          } else {
            setImages(images.filter((image) => image.fileId !== imageId))
            setQuestions({
              ...questions,
              answerOptions: questions.answerOptions.map((answer) =>
                answer.fileId === imageId ? { ...answer, fileId: null } : answer
              ),
            })
          }
        })
        .catch(console.log),

    {}
  )
  const handleEditImageDelete = (imageId) => {
    setToDeleteImages([
      ...toDeleteImages,
      ...images.filter((image) => image.fileId === imageId),
    ])
    setImages(images.filter((image) => image.fileId !== imageId))
    setQuestions({
      ...questions,
      answerOptions: questions.answerOptions.map((answer) =>
        answer.fileId === imageId ? { ...answer, fileId: null } : answer
      ),
    })
  }

  const handleImageDeleteAsync = async (imageId) => {
    await withAuth(`${surveyImagesEndpoint}${imageId}`, {
      method: 'DELETE',
    })
      .then((res) => {
        if ('fieldErrors' in res) {
          // @todo notifications
        }
      })
      .catch(console.log)
  }

  const handleDeleteDoneQuestion = async (doneQuestion) => {
    await fetchDeleteQuestion(doneQuestion.id)
    fetchData()
  }

  const fetchDeleteQuestion = async (questionId) => {
    await withAuth(`${questionDeleteEndpoint}${questionId}`, {
      method: 'DELETE',
    }).catch((e) => console.log(e))
  }

  const handleEditDoneQuestion = async (index, ready, doneQuestion) => {
    setEditDoneQuestion({
      index: index,
      ready: ready,
      doneQuestion: doneQuestion,
    })
    setCurrentQuestionType(doneQuestion.type)
    if (doneQuestion.type === 'IMAGE') {
      const arrayOfDoneFileIds = doneQuestion.answerOptions.map(
        (answer) => answer.fileId
      )
      const indexOfFileId = sentImages.filesId
        .map((fileId, id) => (arrayOfDoneFileIds.includes(fileId) ? id : null))
        .filter((values) => values !== null)
      const files = indexOfFileId.map((id) => sentImages.files[id])
      setImages(
        files.map((file, id) => ({
          file: file,
          questionId: id,
          fileId: doneQuestion.answerOptions[id]?.fileId,
        }))
      )
    }
    setQuestions(doneQuestion)
  }

  return (
    <Layout>
      <Heading title="Ankiety">
        <Button
          link={null}
          onClick={() => mutateHeader(survey)}
          label="Zapisz"
          icon={whiteSaveIcon}
          altTag=""
          imgAriaHidden={true}
          width="auto"
          altTag=""
          srText=""
        />
        <Button
          marginLeft
          link={`/app/preview/${surveyId}`}
          label="Podgląd"
          icon={previewIcon}
          altTag=""
          imgAriaHidden={true}
          width="auto"
          altTag=""
          srText=""
        />
        <Button
          marginLeft
          link={`/app/surveys/send/${surveyId}`}
          label="Udostępnij"
          icon={shareIconUp}
          altTag=""
          imgAriaHidden={true}
          width="auto"
          altTag=""
          srText=""
        />
      </Heading>
      <SurveyWrapper>
        <h2>Tytuł ankiety</h2>
        <Input
          aria-label="Tytuł ankiety"
          maxLength={100}
          value={survey.title}
          onChange={(element) =>
            setSurvey({ ...survey, title: element.target.value })
          }
        />
        <label htmlFor="Opis-ankiety">Opis</label>
        <Input
          name="Opis-ankiety"
          id="Opis-ankiety"
          maxLength={200}
          value={survey.description}
          onChange={(element) =>
            setSurvey({ ...survey, description: element.target.value })
          }
        />
        {doneQuestions !== [] &&
          doneQuestions.map((question, index) =>
            index !== editDoneQuestion.index ? (
              <QuestionWrapper key={index}>
                <>
                  <label htmlFor="Rodzaj pytania">Rodzaj pytania</label>
                  <Input
                    aria-label="Rodzaj pytania"
                    name="Rodzaj pytania"
                    id="Rodzaj pytania"
                    readOnly
                    value={
                      questionType.find((type) => type.value === question.type)
                        .label
                    }
                  />
                  <label htmlFor="Treść pytania">Treść pytania</label>
                  <Input
                  aria-label="Treść pytania"
                    name="Treść pytania"
                    id="Treść pytania"
                    readOnly
                    value={question.question}
                  />
                  {question.type !== 'SHORT' && question.type !== 'LONG' && (
                    <StyledSpan>Odpowiedzi</StyledSpan>
                  )}
                  <ImageTypeWrapper isImageType={question.type === 'IMAGE'}>
                    {question.answerOptions.map((answer, index) => (
                      <Fragment key={index}>
                        <label aria-description="odpowiedź">
                          {answer.answer}
                        </label>
                        {question.type === 'IMAGE' && answer.fileId !== null && (
                          <img
                            style={{
                              width: '50px',
                              maxWidth: '50px',
                              maxHeight: '50px',
                              alignSelf: 'center',
                              justifySelf: 'center',
                            }}
                            src={
                              sentImages.files[
                                sentImages?.filesId.indexOf(answer.fileId)
                              ]
                            }
                          ></img>
                        )}
                      </Fragment>
                    ))}
                  </ImageTypeWrapper>
                  {!editDoneQuestion.ready && (
                    <div style={{ alignSelf: 'end' }}>
                      <TextButton
                        style={{ width: '30px' }}
                        disabled={questions !== null}
                        onClick={() =>
                          handleEditDoneQuestion(index, true, question)
                        }
                      >
                        <img
                          style={{ width: '20px' }}
                          alt="Edytuj pytanie"
                          src={editIcon}
                        ></img>
                      </TextButton>
                      <TextButton
                        style={{ width: '30px' }}
                        disabled={questions !== null}
                        onClick={() => handleDeleteDoneQuestion(question)}
                      >
                        <img
                          style={{ width: '20px' }}
                          alt="Edytuj pytanie"
                          src={deleteIcon}
                        ></img>
                      </TextButton>
                    </div>
                  )}
                </>
              </QuestionWrapper>
            ) : (
              questions &&
              editDoneQuestion.ready && (
                <QuestionWrapper>
                  <>
                    <label htmlFor="question-type">{questions.type}</label>
                    <select
                      id="question-type"
                      disabled
                      defaultValue={currentQuestionType}
                      onChange={(element) =>
                        handleQuestionTypeChange(element.target.value)
                      }
                    >
                      {questionType.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <label>Treść pytania</label>
                    <Input
                    aria-label="Treść pytania"
                      maxLength={200}
                      defaultValue={question.question}
                      onChange={(element) =>
                        setQuestions({
                          ...questions,
                          question: element.target.value,
                        })
                      }
                    />
                    {(currentQuestionType === 'LIKERT' ||
                      currentQuestionType === 'SINGLE' ||
                      currentQuestionType === 'MULTIPLE' ||
                      currentQuestionType === 'IMAGE') && (
                      <>
                        <NewQuestionsWrapper
                          isImageType={currentQuestionType === 'IMAGE'}
                        >
                          {questions.answerOptions.map((answer, index) => (
                            <Fragment key={index}>
                              {editQuestion.id === index ? (
                                <>
                                  <Input
                                    value={
                                      questions.answerOptions[index].answer
                                    }
                                    onChange={(element) =>
                                      handleEditAnswer(element)
                                    }
                                  />
                                 <TextButton
                                    aria-label={`Zapisz odpowiedź ${answer.answer}`}
                                  >
                                  <StyledImg
                                    alt="Zapisz odpowiedź"
                                    src={saveIcon}
                                    onClick={() =>
                                      setEditQuestion({ id: null })
                                    }
                                  ></StyledImg>
                                  </TextButton>
                                  <div></div>
                                </>
                              ) : (
                                <>
                                  <label>{answer.answer}</label>
                                  <TextButton
                                    aria-label={`Usuń odpowiedź ${answer.answer}`}
                                  >
                                    <StyledImg
                                      alt="Usuń odpowiedź"
                                      src={deleteIcon}
                                      onClick={() => handleDeleteAnswer(index)}
                                    ></StyledImg>
                                  </TextButton>
                                  <TextButton
                                    aria-label={`Edytuj odpowiedź ${answer.answer}`}
                                  >
                                    <StyledImg
                                      alt="Edytuj odpowiedź"
                                      src={editIcon}
                                      onClick={() =>
                                        setEditQuestion({ id: index })
                                      }
                                    ></StyledImg>
                                  </TextButton>
                                </>
                              )}
                              {currentQuestionType === 'IMAGE' && (
                                <StyledAnswerWrapper>
                                  {images.filter(
                                    (image) => image.questionId === index
                                  )[0]?.fileId ? (
                                    <TextButton
                                      onClick={() =>
                                        handleEditImageDelete(
                                          images.filter(
                                            (image) =>
                                              image.questionId === index
                                          )[0]?.fileId
                                        )
                                      }
                                    >
                                      Usuń obrazek
                                    </TextButton>
                                  ) : (
                                    <label
                                      tabIndex="0"
                                      style={{ alignSelf: 'center' }}
                                    >
                                      <input
                                        style={{ display: 'none' }}
                                        type="file"
                                        onChange={(element) =>
                                          handleFileUpload(element, index)
                                        }
                                      />
                                      Dodaj obrazek
                                    </label>
                                  )}
                                  <StyledUploadedImg
                                    style={{ alignSelf: 'center' }}
                                    src={
                                      images.filter(
                                        (image) => image.questionId === index
                                      )[0]?.file
                                        ? images.filter(
                                            (image) =>
                                              image.questionId === index
                                          )[0]?.file
                                        : imageIcon
                                    }
                                    alt=""
                                  ></StyledUploadedImg>
                                </StyledAnswerWrapper>
                              )}
                            </Fragment>
                          ))}
                          {newAnswer.ready && (
                            <>
                              <Input
                                maxLength={50}
                                placeholder="Wpisz odpowiedź"
                                onChange={(element) =>
                                  currentQuestionType === 'IMAGE'
                                    ? setNewAnswer({
                                        ready: true,
                                        answer: element.target.value,
                                      })
                                    : setNewAnswer({
                                        ready: true,
                                        answer: element.target.value,
                                      })
                                }
                              ></Input>
                            <TextButton
                              aria-label={`Zapisz odpowiedź ${newAnswer.answer}`}
                            >
                              <StyledImg
                                alt="Zapisz odpowiedź"
                                src={saveIcon}
                                onClick={() => handleAddAnswer()}
                              ></StyledImg>
                              </TextButton>
                            </>
                          )}
                        </NewQuestionsWrapper>
                        <TextButton
                          marginTop
                          onClick={() =>
                            currentQuestionType === 'IMAGE'
                              ? setNewAnswer({
                                  ready: true,
                                  answer: null,
                                })
                              : setNewAnswer({
                                  ready: true,
                                  answer: null,
                                })
                          }
                        >
                          <StyledImg
                            src={addIconRed}
                            alt="Dodaj odpowiedź"
                          ></StyledImg>
                          Dodaj odpowiedź
                        </TextButton>
                      </>
                    )}
                  </>
                  <div style={{ alignSelf: 'end' }}>
                    <StyledButton
                      onClick={() => handleAbortEditQuestion()}
                      label={null}
                      link={null}
                      icon={null}
                    >
                      Anuluj
                    </StyledButton>
                    <StyledButton
                      onClick={() => handleAddQuestion()}
                      label={null}
                      link={null}
                      icon={null}
                    >
                      Zapisz pytanie
                    </StyledButton>
                  </div>
                </QuestionWrapper>
              )
            )
          )}
        {questions && !editDoneQuestion.ready && (
          <QuestionWrapper ref={bottom}>
            <>
              <label htmlFor="Rodzaj pytania">Rodzaj pytania</label>
              <select
              aria-label="Rodzaj pytania"
                id="type-of-question"
                onChange={(element) =>
                  handleQuestionTypeChange(element.target.value)
                }
              >
                {questionType.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <label>Treść pytania</label>
              <Input
              aria-label="Treść pytania"
                maxLength={200}
                onChange={(element) =>
                  setQuestions({
                    ...questions,
                    question: element.target.value,
                  })
                }
              />
              {(currentQuestionType === 'LIKERT' ||
                currentQuestionType === 'SINGLE' ||
                currentQuestionType === 'MULTIPLE' ||
                currentQuestionType === 'IMAGE') && (
                <>
                  <NewQuestionsWrapper
                    isImageType={currentQuestionType === 'IMAGE'}
                  >
                    {questions.answerOptions.map((answer, index) => (
                      <Fragment key={index}>
                        {editQuestion.id === index ? (
                          <>
                            <Input
                              value={questions.answerOptions[index].answer}
                              onChange={(element) => handleEditAnswer(element)}
                            />
                            
                            <TextButton
                              aria-label={`Zapisz odpowiedź ${answer.answer}`}
                            >
                            <StyledImg
                              alt="Zapisz odpowiedź"
                              src={saveIcon}
                              onClick={() => setEditQuestion({ id: null })}
                            ></StyledImg>
                            </TextButton>
                            <div></div>
                          </>
                        ) : (
                          <>
                            <label>{answer.answer}</label>
                            <TextButton
                              aria-label={`Usuń odpowiedź ${answer.answer}`}
                            >
                              <StyledImg
                                alt=""
                                src={deleteIcon}
                                onClick={() => handleDeleteAnswer(index)}
                              ></StyledImg>
                            </TextButton>
                            <TextButton
                              aria-label={`Edytuj odpowiedź ${answer.answer}`}
                            >
                              <StyledImg
                                alt=""
                                src={editIcon}
                                onClick={() => setEditQuestion({ id: index })}
                              ></StyledImg>
                            </TextButton>
                          </>
                        )}
                        {currentQuestionType === 'IMAGE' && (
                          <StyledAnswerWrapper>
                            {images.filter(
                              (image) => image.questionId === index
                            )[0]?.fileId ? (
                              <TextButton
                                onClick={() =>
                                  handleImageDelete(
                                    images.filter(
                                      (image) => image.questionId === index
                                    )[0]?.fileId
                                  )
                                }
                              >
                                Usuń obrazek
                              </TextButton>
                            ) : (
                              <label
                                tabIndex="0"
                                style={{ alignSelf: 'center' }}
                              >
                                <input
                                  style={{ display: 'none' }}
                                  type="file"
                                  onChange={(element) =>
                                    handleFileUpload(element, index)
                                  }
                                />
                                Dodaj obrazek
                              </label>
                            )}
                            <StyledUploadedImg
                              style={{ alignSelf: 'center' }}
                              src={
                                images.filter(
                                  (image) => image.questionId === index
                                )[0]?.file
                                  ? images.filter(
                                      (image) => image.questionId === index
                                    )[0]?.file
                                  : imageIcon
                              }
                              alt=""
                            ></StyledUploadedImg>
                          </StyledAnswerWrapper>
                        )}
                      </Fragment>
                    ))}
                    {newAnswer.ready && (
                      <>
                        <Input
                          maxLength={50}
                          placeholder="Wpisz odpowiedź"
                          onChange={(element) =>
                            currentQuestionType === 'IMAGE'
                              ? setNewAnswer({
                                  ready: true,
                                  answer: element.target.value,
                                })
                              : setNewAnswer({
                                  ready: true,
                                  answer: element.target.value,
                                })
                          }
                        ></Input>
                          <TextButton
                              aria-label={`Zapisz odpowiedź ${newAnswer.answer}`}
                            >
                        <StyledImg
                          alt="Zapisz odpowiedź"
                          src={saveIcon}
                          onClick={() => handleAddAnswer()}
                        ></StyledImg>
                        </TextButton>
                      </>
                    )}
                  </NewQuestionsWrapper>
                  <TextButton
                    marginTop
                    onClick={() =>
                      currentQuestionType === 'IMAGE'
                        ? setNewAnswer({
                            ready: true,
                            answer: null,
                          })
                        : setNewAnswer({
                            ready: true,
                            answer: null,
                          })
                    }
                  >
                    <StyledImg src={addIconRed} alt=""></StyledImg>
                    Dodaj odpowiedź
                  </TextButton>
                </>
              )}
            </>
            <div style={{ alignSelf: 'end' }}>
              <StyledButton
                onClick={() => handleAbort()}
                label={null}
                link={null}
                icon={null}
              >
                Anuluj
              </StyledButton>
              <StyledButton
                onClick={() => handleAddQuestion()}
                label={null}
                link={null}
                icon={null}
              >
                Zapisz pytanie
              </StyledButton>
            </div>
          </QuestionWrapper>
        )}

        <StyledSaveQuestionButton
          disabled={questions !== null}
          onClick={() => setQuestions(initialValuesSingle)}
          label={'Dodaj pytanie'}
          link={null}
          icon={null}
        ></StyledSaveQuestionButton>
      </SurveyWrapper>
    </Layout>
  )
}

export default EditSurvey

const QuestionWrapper = styled.div`
  display: flex;
  margin: 1rem 0;
  border-radius: 6px;
  border: 1px solid ${colors.light_black};
  border-left: 5px solid ${colors.monza};
  flex-direction: column;
  padding: 1rem;
  align-items: baseline;
  color: black;
  select {
    min-width: 100%;
    margin: 5px 0;
    border: ${(props) =>
      props.selected
        ? `1px solid ${colors.monza}`
        : `1px solid ${colors.light_black}`};
    font-size: 14px;
    font-weight: 100;
    padding: 10px 15px;
    border-radius: 4px;
    height: 46px;
    box-sizing: border-box;
    &:disabled {
      background: #ebebe4;
    }
    &:focus {
      outline: 2px solid ${colors.monza};
      box-shadow: 0 0 0 1px ${colors.monza};
    }
  }
  textarea {
    height: 7rem;
  }
  label {
    margin: 0px 1px;
    font-size: 12px;
  }
  input {
    width: 100%;
  }
`
const StyledSpan = styled.span`
  margin: 1em 0;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
`
const StyledAnswerWrapper = styled.div`
  display: flex;
`
const SurveyWrapper = styled.div`
  margin: 3vh 20vw 0px 20vw;
  display: flex;
  flex-flow: column;
`
const ImageTypeWrapper = styled.div`
  input {
    width: 100%;
  }
  width: 100%;
  ${(props) =>
    props.isImageType
      ? `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: '. .';
  `
      : `
  display: flex;
  flex-direction: column;`}
`
const NewQuestionsWrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: '${(props) =>
    props.isImageType ? '. . . .' : '. . .'}';
  align-items: center;
`
const StyledImg = styled.img`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  height: 11px;
  cursor: pointer;
  width: 11px;
`
const StyledUploadedImg = styled.img`
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  height: 36px;
  width: 36px;
`
const Input = styled.input`
  min-width: 97.5%;
  margin: 5px 0;
  border: ${(props) =>
    props.selected
      ? `1px solid ${colors.monza}`
      : `1px solid ${colors.light_black}`};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:read-only {
    background: ${colors.readOnly};
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0 0 0 1px ${colors.monza};
  }
`
const StyledButton = styled(Button)`
  width: auto;
  padding: 2px 5px;
  margin-left: 0.5em;
`
const StyledSaveQuestionButton = styled(Button)`
  width: 150px;
  margin-bottom: 2em;
  align-self: end;
`
const TextButton = styled.button`
  ${(props) => props.marginTop && 'margin-top: 1rem;'}
  background: none;
  border: none;
  color: ${colors.monza};
  padding: 0;
  font-size: 12px;
  font-weight: 100;
  cursor: pointer;
`
